import React from 'react'
import { defaultProps } from './index'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const AttivitaCardSettings = (settingsProps) => {
  return (
    <>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
          <CtaToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const AttivitaCardFloatingSettings = () =>
  React.createElement(AttivitaCardSettings, { floating: true })
